import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AboutComponent } from "./../about/about.component";
import { ContactComponent } from "./../contact/contact.component";
import { HomeComponent } from "./../home/home.component";
import { MainComponent } from "./main.component";
import { PortfolioComponent } from "./../portfolio/portfolio.component";

const routes: Routes = [
  {
    path: "",
    component: MainComponent,
    children: [
      {
        path: "",
        component: HomeComponent,
      },
      {
        path: "about",
        component: AboutComponent,
      },
      {
        path: "contact",
        component: ContactComponent,
      },
      {
        path: "portfolio",
        component: PortfolioComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
